import EntradasTab from "./EntradasTab";

export default EntradasTab;